import "./Privacy.module.css";
import Header from "@/reusable_sections/Header";
import Dataschutzcontent from "./sections/Dataschutzcontent";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Header />
      <Dataschutzcontent />
      <Footer />
    </div>;
}